import { useFeature } from "byzantine";
import {
  RecipientDrawer,
  DRAWER_TYPES,
  SECTION_NAMES,
} from "../../../RecipientDrawer";
import { RecipientDrawer as NewRecipientDrawer } from "../../../../src/modules/recipientDrawer";
import type useRecipientDrawerState from "./useRecipientDrawerState";

interface BulkRecipientDrawerProps {
  drawerState: ReturnType<typeof useRecipientDrawerState>;
}

const BulkRecipientDrawer = ({ drawerState }: BulkRecipientDrawerProps) => {
  const isNewDrawerEnabled = useFeature().featureEnabled("recipient_drawer");
  const {
    isRecipientDrawerOpen,
    typeOfRecipientDrawer,
    selectedRecipientId,
    selectedRowIndex,
    customAlertCopy,
    handleCloseDrawer,
  } = drawerState;

  if (isNewDrawerEnabled) {
    // the new drawer has no row or alert props: the table keeps the row, and
    // the ACH flow shows the same missing-details warning on its own
    return (
      <NewRecipientDrawer
        isOpen={isRecipientDrawerOpen}
        flow="ach"
        onClose={({ recipient }) =>
          handleCloseDrawer(recipient?.id, selectedRowIndex)
        }
        {...(typeOfRecipientDrawer === DRAWER_TYPES.edit && selectedRecipientId
          ? { mode: "edit", recipientId: selectedRecipientId }
          : { mode: "create" })}
      />
    );
  }

  return (
    <RecipientDrawer
      recipientId={selectedRecipientId}
      handleClose={handleCloseDrawer}
      isOpen={isRecipientDrawerOpen}
      fromACHFlow={true}
      drawerType={typeOfRecipientDrawer}
      rowIndex={selectedRowIndex}
      customAlertCopy={customAlertCopy}
      defaultSectionToOpen={customAlertCopy ? SECTION_NAMES.ach : undefined}
    />
  );
};

export default BulkRecipientDrawer;
